import { useEffect, useRef } from 'react';
import { formatTextWithItalics } from '@/utils/TextFormatter';
import { useTranslation } from 'react-i18next';

interface TransportationFeeProps {
  onFeeChange: (fee: { title: string; price: string }) => void;
}

const TransportationFee = ({ onFeeChange }: TransportationFeeProps) => {
  // Fixed transportation fee
  const TRANSPORTATION_FEE = 25;
  const ZONE_NAME = 'Klang/Selangor';
  const didAddFee = useRef(false); // Use ref to track if we've already added the fee
  const { t } = useTranslation();

  // Automatically add the transportation fee only once when the component mounts
  useEffect(() => {
    // Only add the fee once to avoid unnecessary state updates
    if (!didAddFee.current) {
      const feeTitle = `${t('fees.title')} (${ZONE_NAME})`;
      const feePrice = `RM${TRANSPORTATION_FEE.toFixed(2)}`;
      onFeeChange({ title: feeTitle, price: feePrice });
      didAddFee.current = true;
    }
  }, [onFeeChange]); // Add onFeeChange to the dependency array

  return (
    <div className="mt-4 border-t pt-4">
      <div className="bg-yellow-50 p-4 rounded-md border border-yellow-200">
        <p className="font-medium text-base mb-1">
          {formatTextWithItalics(t('fees.title'))}
        </p>
        <p className="text-sm text-gray-700 mb-2">
          {t('fees.description_1')} {ZONE_NAME} {t('fees.description_2')}{TRANSPORTATION_FEE.toFixed(2)}
        </p>
        <p className="text-xs text-red-600 font-medium">
          {t('fees.alert')}
        </p>
      </div>
    </div>
  );
};

export default TransportationFee; 